<template>
  <picture v-if="image.breakPoints" class="v-picture">
    <template
      v-for="(img, index) in image.breakPoints"
    >
      <v-picture-source
        v-if="img.hasOwnProperty('webp')"
        :key="`imageWebP-${index}`"
        :value="img"
        :media-prop="index"
        type-image="image/webp"
      />
      <v-picture-source
        :key="`imageMain-${index}`"
        :value="img"
        :media-prop="index"
      />
      <img
        :key="`imageSource-${index}`"
        :src="mainSrc"
        :alt="alt"
        :title="title"
        :class="addClass"
      >
    </template>
  </picture>
  <img
    v-else
    :src="mainSrc"
    :alt="alt"
    :title="title"
    :class="addClass"
  >
</template>
<script>
import VPictureSource from '@/components/v-picture-source.vue';

export default {
  name: 'v-picture',
  components: {
    VPictureSource,
  },
  props: {
    image: {
      type: [Object, Array],
      default: () => {},
    },
    title: {
      type: String,
      required: false,
      default: '',
    },
    alt: {
      type: String,
      required: false,
      default: '',
    },
    addClass: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      noPhotoSrc: '/NO_PHOTO_PATH',
    };
  },
  computed: {
    mainSrc() {
      let url = '';
      if (this.image) {
        if (this.image?.breakPoints['*']) {
          url = this.image.breakPoints['*'].src;
        } else {
          url = this.noPhotoSrc;
        }
      } else {
        url = this.noPhotoSrc;
      }
      return url;
    },
  },
};
</script>
